import { ApiCall } from '@lcms/api-definition';
import endpoints from '../api-endpoint-definition.json';
import { ApiResponse } from './api-response';

const definition = new ApiCall<ApiResponse>().post('clearWordpressCache', {
    route: endpoints.adminWordpressTopicsClear
})
export default definition;